import { Component, Input, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { ImgCacheServiceProvider } from '../../providers/img-cache-service/img-cache-service';
import { ModalController } from 'ionic-angular';

/**
 * Generated class for the LazyImgComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lazy-img',
  templateUrl: 'lazy-img.html'
})
export class LazyImgComponent {

  @Input() content;
  @Input() data;
  @Input() type;
  @Input() userid;
  @Input() userinitial; // for profile when loading or errror
  @Input() roomid; // for chat
  @Input() picture;
  @Input() viewable;
  @Input() isProfile;
  @Input() pinch:boolean = false;

  @Input('source') // double check
  public source: string = '';

  @Output()
  public loaded: EventEmitter<void> = new EventEmitter<void>();

  public loadListener: () => void;
  public errorListener: () => void;

  private cacheSubscription: Subscription;

  constructor(
    public el: ElementRef,
    public imgCacheService: ImgCacheServiceProvider,
    public renderer: Renderer2,
    public modalCtrl: ModalController
  ) { }

  public ngOnInit(): void {
    // get img element
    const nativeElement: HTMLElement = this.el.nativeElement;
    // add load listener
    this.loadListener = this.renderer.listen(nativeElement, 'load', () => {
      this.renderer.addClass(nativeElement, 'loaded');
      this.loaded.emit();
    });

    this.errorListener = this.renderer.listen(nativeElement, 'error', () => {
      nativeElement.remove();
    });

    // cache img and set the src to the img
    this.cacheSubscription =
      this.imgCacheService
        .cache(this.source)
        .subscribe((value) => {
          this.renderer.setAttribute(nativeElement, 'src', value);
        }, (e) => console.log(e));
  }

  public ngOnDestroy(): void {
    // remove listeners
    this.loadListener();
    this.errorListener();
    this.cacheSubscription.unsubscribe();
  }

  public viewImages(imageUrl) {
    if (this.viewable) {
      const modal = this.modalCtrl.create('ImageViewerPage', {
        images: imageUrl
      });
      modal.present();
    }
  }

}





// WEBPACK FOOTER //
// ./src/components/lazy-img/lazy-img.ts